import {createSlice,createAsyncThunk,createEntityAdapter} from "@reduxjs/toolkit";
import useHttp from '../../hooks/useHttp'

const newsAdapter = createEntityAdapter()
const initialState = newsAdapter.getInitialState(
    {
        newsLoadingStatus:'false'
    })
console.log(initialState)
export const fetchNews = createAsyncThunk(
    "news/fetchNews",
    async ()=>{
        const {request} = useHttp()
        return await request("http://localhost:3001/news")
    }
)
 export const newsSlice=createSlice({
    name:"news",
    initialState,
    reducers:{
        addNews:(state,action)=>{newsAdapter.addOne(state,action.payload)},
        deleteItem:(state,action)=>{newsAdapter.removeOne(state,action.payload)}
    },
    extraReducers:builder => {
        builder
            .addCase(fetchNews.pending,state=>{state.isLoading="loading"})
            .addCase(fetchNews.fulfilled,(state,action)=>{
                state.isLoading='false'
                newsAdapter.setAll(state,action.payload)
                // state.news=action.payload;
            })
            .addCase(fetchNews.rejected,state => {state.isLoading="error"})
            .addDefaultCase(()=>{})
    }
})

const{actions,reducer} = newsSlice
export const {selectAll} = newsAdapter.getSelectors(state => state.news)
export default reducer;
export const {newsFetching,newsFetched,newsFetchingError,addNews,deleteItem}=actions